import { FMatQuadrantGraphNode, FMatQuadrantRenderer } from "@dino/shared"
import { Box, Button, Text } from "grommet"
import React, { useMemo } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDinoMirrorPaperQuery } from "../../../generated-types"
import DiagLayout from "../../../components/DiagLayout"
import { useTranslation } from "react-i18next"

const GRAPH_WIDTH = 330

export default () => {
  const { paperId } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data, loading, startPolling, stopPolling } = useDinoMirrorPaperQuery({
    variables: { paperId },
    pollInterval: 5000,
  })

  const mirror = data?.dinoMirrorPaper

  const selfValue = useMemo(() => {
    if (!mirror?.selfPaper?.results || mirror.selfPaper.results.length < 4) return null
    return mirror.selfPaper.results.slice(0, 4)
  }, [mirror?.selfPaper])

  const partnerValue = useMemo(() => {
    if (!mirror?.partnerPaper?.results || mirror.partnerPaper.results.length < 4) return null
    return mirror.partnerPaper.results.slice(0, 4)
  }, [mirror?.partnerPaper])

  if (loading && !data) return null

  const bothComplete = mirror?.bothComplete

  if (bothComplete) stopPolling()

  return (
    <DiagLayout>
      <Text size="24px" weight="bold" margin={{ bottom: "10px" }}>
        {t("result")}
      </Text>

      {!bothComplete ? (
        <Box align="center" pad="large" gap="medium">
          <Text size="18px" color="#777">
            상대방이 진단 완료하기를 기다리는 중입니다
          </Text>
          <Button
            label="진단 결과 확인"
            primary
            color="#C02026"
            onClick={() => startPolling(3000)}
          />
        </Box>
      ) : (
        <Box align="center">
          <FMatQuadrantRenderer width={GRAPH_WIDTH}>
            {selfValue && (
              <FMatQuadrantGraphNode value={selfValue} strokeColor="#16A34A" opacity={1.0} />
            )}
            {partnerValue && (
              <FMatQuadrantGraphNode value={partnerValue} strokeColor="#C02026" opacity={0.7} />
            )}
          </FMatQuadrantRenderer>

          <Box direction="row" gap="medium" margin={{ top: "15px" }} align="center">
            <Box direction="row" gap="xsmall" align="center">
              <Box width="14px" height="14px" round="full" background="#16A34A" />
              <Text size="14px">
                {mirror?.selfName || "본인"}
              </Text>
            </Box>
            <Box direction="row" gap="xsmall" align="center">
              <Box width="14px" height="14px" round="full" background="#C02026" style={{ opacity: 0.7 }} />
              <Text size="14px">
                {mirror?.partnerName || "상대"}
              </Text>
            </Box>
          </Box>

          <Box margin={{ top: "medium" }}>
            <Button
              label={t("button.confirm")}
              primary
              color="#C02026"
              onClick={() => navigate("/my")}
            />
          </Box>
        </Box>
      )}
    </DiagLayout>
  )
}
